// extracted by mini-css-extract-plugin
export default {"GitlabPagesSite":"GitlabPagesSite_GitlabPagesSite__G+MdL"};